import React from 'react'
import { Route } from 'react-router-dom'
import { RoleSysRequestLog } from '../../../../role/components/role-sys'
import { NoAccess } from '../../../../role/components/no-access'
import { RequestLogPage } from './request-log-page'

// /admin/request-log is the list; /admin/request-log/:requestID opens one
// request in the drawer over it. The route itself is gated by
// SYS_REQUEST_LOG (not only its sidebar entry), so a typed URL without it
// shows NoAccess instead of a page whose every read is refused.
export const LayoutRequestLog = () =>
  <Route path="/admin/request-log/:requestID?">
    <RoleSysRequestLog accessRead fallback={<NoAccess what="the request log" />}>
      <RequestLogPage />
    </RoleSysRequestLog>
  </Route>
